


$(document).ready(function(){

const talen = document.querySelectorAll('button[name="locale_code"]');

talen.forEach(taal => {
  taal.style.display = 'block';
});

const NL = document.querySelectorAll('button[value="NL"]');

NL.forEach(NL1 => {
  NL1.style.display = 'inline-flex';
});  


const FR = document.querySelectorAll('button[value="FR"]');

FR.forEach(FR1 => {
  FR1.style.display = 'inline-flex';
});  


const CH = document.querySelectorAll('button[value="CH"]');

CH.forEach(CH1 => {
  CH1.style.display = 'inline-flex';
});  



const GB = document.querySelectorAll('button[value="GB"]');

GB.forEach(GB1 => {
  GB1.style.display = 'inline-flex';
});  


const IT = document.querySelectorAll('button[value="IT"]');

IT.forEach(IT1 => {
  IT1.style.display = 'inline-flex';
});  



const DE = document.querySelectorAll('button[value="DE"]');

DE.forEach(DE1 => {
  DE1.style.display = 'inline-flex';
});  



const BE = document.querySelectorAll('button[value="BE"]');

BE.forEach(BE1 => {
  BE1.style.display = 'inline-flex';
});  


const US = document.querySelectorAll('button[value="US"]');

US.forEach(US1 => {
  US1.style.display = 'inline-flex';
});  





const CA = document.querySelectorAll('button[value="CA"]');

CA.forEach(CA1 => {
  CA1.style.display = 'inline-flex';
});  
  
	
	

const AU = document.querySelectorAll('button[value="AU"]');

AU.forEach(AU1 => {
  AU1.style.display = 'inline-flex';
});  
	
  

	
	

const PT = document.querySelectorAll('button[value="PT"]');

PT.forEach(PT1 => {
  PT1.style.display = 'inline-flex';
});  
	
  


	
	

const SE = document.querySelectorAll('button[value="SE"]');

SE.forEach(SE1 => {
  SE1.style.display = 'inline-flex';
});  
	
  


	
	

const DK = document.querySelectorAll('button[value="DK"]');

DK.forEach(DK1 => {
  DK1.style.display = 'inline-flex';
});  
	
  

	
	

const NO = document.querySelectorAll('button[value="NO"]');

NO.forEach(NO1 => {
  NO1.style.display = 'inline-flex';
});  
	
  


	
	

const AT = document.querySelectorAll('button[value="AT"]');

AT.forEach(AT1 => {
  AT1.style.display = 'inline-flex';
});  
	
  


	
	

const ES = document.querySelectorAll('button[value="ES"]');

ES.forEach(ES1 => {
  ES1.style.display = 'inline-flex';
});  
	
  







document.querySelector('button[value="NO"]').style.display = 'inline-flex';

document.querySelector('button[value="AT"]').style.display = 'inline-flex';

document.querySelector('button[value="ES"]').style.display = 'inline-flex';


$('.product-info__text').prepend('');

});